export const PACKAGES = {
  essential: {
    name: "Essential",
    price: 129,
    features: ["Bookkeeping", "Xero setup", "Bank reconciliation", "MTD ready"],
  },
  growth: {
    name: "Growth",
    price: 249,
    features: ["Everything in Essential", "VAT return preparation", "Supplier/customer reviews", "Quarterly finance review", "MTD compliance"],
  },
  business_partner: {
    name: "Business Partner",
    price: 549,
    features: ["Everything in Growth", "Monthly management accounts", "Cash flow monitoring", "KPI reporting", "Performance insights"],
  },
  finance_director_lite: {
    name: "Finance Director Lite",
    price: 900,
    features: ["Everything in Business Partner", "Strategic finance support", "Cash flow forecasting", "Budgeting & scenario planning", "Monthly business review"],
  },
  custom: {
    name: "Custom",
    price: 0,
    features: ["Bespoke scope", "Work outside a package billed at £35/hour"],
  },
};

export const HOURLY_RATE = 35;

export const ENTITY_TYPES = [
  { value: "sole_trader", label: "Sole trader" },
  { value: "landlord", label: "Landlord" },
  { value: "limited_company", label: "Limited company" },
  { value: "partnership", label: "Partnership" },
];

export const VAT_STAGGERS = [
  { value: "1", label: "Stagger 1 (Mar / Jun / Sep / Dec)" },
  { value: "2", label: "Stagger 2 (Apr / Jul / Oct / Jan)" },
  { value: "3", label: "Stagger 3 (May / Aug / Nov / Feb)" },
];

export const STATUS_LABELS = {
  upcoming: "Upcoming",
  awaiting_client: "Awaiting client",
  to_review: "To review",
  completed: "Completed",
};

export function gbp(n) {
  return "£" + Number(n || 0).toLocaleString("en-GB", { maximumFractionDigits: 0 });
}

export function fmtDate(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
}

export function entityLabel(v) {
  return ENTITY_TYPES.find((e) => e.value === v)?.label || v;
}
